import { createContext } from "react"

const PersistedValuesContext = createContext<any>({})

export default PersistedValuesContext
